import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import DashboardPage from './pages/DashboardPage.vue';
import BuilderPage from './pages/BuilderPage.vue';
import ResponsesPage from './pages/ResponsesPage.vue';
import PublicFormPage from './pages/PublicFormPage.vue';
import LoginPage from './pages/LoginPage.vue';
import ConsentJournalPage from './pages/ConsentJournalPage.vue';
import UsersPage from './pages/UsersPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import './styles.css';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: DashboardPage },
    { path: '/login', component: LoginPage },
    { path: '/forms/new', component: BuilderPage },
    { path: '/forms/:id/edit', component: BuilderPage },
    { path: '/forms/:id/responses', component: ResponsesPage },
    { path: '/consent-journal', component: ConsentJournalPage },
    { path: '/users', component: UsersPage },
    { path: '/settings', component: SettingsPage },
    { path: '/f/:slug', component: PublicFormPage },
    { path: '/embed/:slug', component: PublicFormPage, props: { embedded: true } }
  ]
});

// Последняя страница админки запоминается, чтобы после входа вернуть на неё (например, к ответу по ссылке из письма).
const RETURN_KEY = 'forma.returnTo';
router.afterEach((to) => {
  if (to.path === '/login' || to.path.startsWith('/f/') || to.path.startsWith('/embed/')) return;
  try { sessionStorage.setItem(RETURN_KEY, to.fullPath); } catch { /* хранилище недоступно */ }
});

createApp(App).use(router).mount('#app');
